/* eslint-disable no-shadow */
export enum PaymentStatus {
    paid = "paid",
}
